import React, { useEffect, useRef, useState } from 'react';
import { useSpring, useSpringRef, useChain, animated, config } from '@react-spring/web';
import { getRect } from '../tooltip/utils';
import { Aside, AsideInner } from './styles';
import cx from 'classnames';
const MinWidth = 300;
export const LayoutAside = (props) => {
    const [w, setW] = useState();
    const domRef = useRef(null);
    const opacityRef = useSpringRef();
    const opacityStyle = useSpring({
        opacity: props.open ? 1 : 0,
        config: config.default,
        ref: opacityRef,
    });
    const widthRef = useSpringRef();
    const widthStyle = useSpring({
        width: props.open ? w : 0,
        config: config.default,
        ref: widthRef,
    });
    useEffect(() => {
        const rect = getRect(domRef);
        setW(Math.max(rect.width, MinWidth));
    }, [domRef]);
    useChain(props.open ? [widthRef, opacityRef] : [opacityRef, widthRef], [0, 0.2]);
    return (React.createElement(Aside, { style: props.style, "data-role": "layout-aside", className: cx('layout-aside', props.className) },
        React.createElement(animated.div, { "data-role": "aside-inner", style: widthStyle },
            React.createElement(AsideInner, { "data-role": "aside-inner-content", style: opacityStyle, ref: domRef }, props.children))));
};
